// src/Components/DeviceSettingsEditor.jsx
import React, { useEffect, useState } from 'react';
import api from '../utils/api';                  // ✅ default import
import '../css/DeviceSettingsEditor.css';

export default function DeviceSettingsEditor({ deviceData, onBack }) {
  // 폼 상태 (초기엔 빈 값 → deviceData 바뀌면 동기화)
  const [id, setId] = useState('');
  const [memo, setMemo] = useState('');
  const [location, setLocation] = useState('');
  const [allLocations, setAllLocations] = useState([]);
  const [loading, setLoading] = useState(false);

  // deviceData → 폼 동기화
  useEffect(() => {
    if (!deviceData) return;
    setId(deviceData.id || '');
    setMemo(deviceData.memo || '');
    setLocation(deviceData.location?.name || '');
  }, [deviceData]);

  // 위치 목록 로드
  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const res = await api.get('/locations');
        if (!ignore) setAllLocations(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error('위치 목록 로드 실패', err);
        if (!ignore) setAllLocations([]);
      }
    })();
    return () => { ignore = true; };
  }, []);

  const handleSubmit = async () => {
    if (!deviceData?.id) {
      alert('디바이스 정보를 불러오는 중입니다. 잠시 후 다시 시도해주세요.');
      return;
    }
    if (!id.trim()) {
      alert('디바이스 이름을 입력하세요.');
      return;
    }

    const confirmed = window.confirm('정말 이 설정을 저장하시겠습니까?');
    if (!confirmed) return;

    const finalLocation = location || deviceData.location?.name || '';

    try {
      setLoading(true);
      await api.put(`/devices/${deviceData.id}`, {
        id,
        memo,
        location: finalLocation,
      });
      alert('✅ 설정이 저장되었습니다.');
      onBack?.();
    } catch (error) {
      console.error('설정 저장 실패:', error);
      alert('❌ 설정 저장에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="device-settings-editor">
      <h3>⚙ 디바이스 설정 변경</h3>

      <label>📋 디바이스 이름</label>
      <input
        type="text"
        value={id}
        onChange={(e) => setId(e.target.value)}
        placeholder="디바이스 이름을 입력하세요"
      />

      <label>📝 메모</label>
      <input
        type="text"
        value={memo}
        onChange={(e) => setMemo(e.target.value)}
        placeholder="메모를 입력하세요"
      />

      <label>📍 설치 위치 변경</label>
      <select
        value={location}
        onChange={(e) => setLocation(e.target.value)}
      >
        <option value="">-- 위치 선택 --</option>
        {allLocations.map((loc) => (
          <option key={loc.id ?? loc.name} value={loc.name}>
            {loc.name}
          </option>
        ))}
      </select>

      <div className="device-settings-buttons">
        <button onClick={handleSubmit} disabled={loading}>
          {loading ? '저장 중…' : '💾 저장'}
        </button>
        <button onClick={onBack}>🔙 뒤로가기</button>
      </div>
    </div>
  );
}
